// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1ruS6","validationTips":"StatementDescriptor_validationTips__3zen6"};